import { render, staticRenderFns } from "./nq5c-AW2025.vue?vue&type=template&id=27872d8a&scoped=true"
import script from "./nq5c-AW2025.vue?vue&type=script&lang=js"
export * from "./nq5c-AW2025.vue?vue&type=script&lang=js"
import style0 from "./nq5c-AW2025.vue?vue&type=style&index=0&id=27872d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27872d8a",
  null
  
)

export default component.exports